import React from 'react';
import { Form, Input, AutoComplete } from 'antd';

const { Option } = AutoComplete;

const AutoCompleteField = ({
  label,
  name,
  rules,
  options,
  handleOnChange,
  placeHolder,
  valueName,
  labelName,
  handleOnSelect,
}) => {
  // const[value, setValue] = useState(null);
  const children = options.map((option, index) => (
    <Option key={option.id ? option.id : index} value={valueName ? option[valueName] : option}>
      {labelName ? option[labelName] : option}
    </Option>
  ));
  return (
    <Form.Item label={label} name={name} rules={rules}>
      <AutoComplete onChange={handleOnChange} placeholder={placeHolder} onSelect={handleOnSelect}>
        {children}
      </AutoComplete>
    </Form.Item>
  );
};

export default AutoCompleteField;
